module.exports = __webpack_public_path__ + "fonts/gabyPro_30c444fc1f38eacadd87402c9eaf4f7c.ttf";